import Button, {
  ButtonType,
} from "immigram-ui-cmon/src/components/Button/Button";
import Heading from "immigram-ui-cmon/src/components/Heading/Heading";
import { Icon24Doc } from "immigram-ui-cmon/src/components/Icons";
import Paragraph from "immigram-ui-cmon/src/components/Paragraph/Paragraph";
import clsxm from "immigram-ui-cmon/src/lib/clsxm";
import { useTranslation } from "next-i18next";
import * as React from "react";

import BgPatternSvg1 from "./assets/stripe-1.svg";
import BgPatternSvg2 from "./assets/stripe-2.svg";

export enum BestPracticeBannerBgPattern {
  Pattern1,
  Pattern2,
}

interface BestPracticeBannerProps {
  title: string;
  text: string;
  buttonText: string;
  buttonHref?: string;
  onButtonClick?: (e: unknown) => void;
  className?: string;
  bgPattern?: BestPracticeBannerBgPattern;
}

function BestPracticeBanner({
  title,
  text,
  buttonText,
  buttonHref,
  onButtonClick,
  className,
  bgPattern = BestPracticeBannerBgPattern.Pattern2,
}: BestPracticeBannerProps) {
  const { t } = useTranslation();

  const bgPatternSvg = {
    [BestPracticeBannerBgPattern.Pattern1]: (
      <BgPatternSvg1 className="absolute bottom-0 right-0 h-[150px] w-full" />
    ),
    [BestPracticeBannerBgPattern.Pattern2]: (
      <BgPatternSvg2 className="absolute bottom-0 right-0 h-full w-full" />
    ),
  }[bgPattern];

  return (
    <div
      className={clsxm(
        "relative overflow-hidden rounded-2xl bg-[#F4F7FB] p-5",
        className
      )}
    >
      {bgPatternSvg}
      <Button
        className="p-0"
        disabled
        type={ButtonType.Flat}
        size="200"
        icon={<Icon24Doc />}
      >
        {t("application:bestPracticeBanner.caption")}
      </Button>
      <Heading tag="h7" className="mt-3 mb-2">
        {title}
      </Heading>
      <Paragraph className="text-[15px] text-black-600">{text}</Paragraph>
      {buttonHref ? (
        <Button
          href={buttonHref}
          target="_blank"
          rel="nofollow"
          type={ButtonType.PrimaryInverse}
          size="200"
        >
          {buttonText}
        </Button>
      ) : (
        <Button
          type={ButtonType.PrimaryInverse}
          size="200"
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
}

export default BestPracticeBanner;
